import { useLayoutEffect } from "react";
import { useDispatchLegends } from "./legendContext";


export const CleanLegends = () => {
    const dispatch = useDispatchLegends() ?? null;
    //console.log("Clean")
    useLayoutEffect(() => {
        if (dispatch) {
            dispatch({ type: 'removeAllLegend' })
        }
    });
}
